import type { TimeRangeLane, TimeSeriesChartRangeTrack } from '../TimeSeriesChart.types';

export function getHighlightedLanes(
  rangeTrack: TimeSeriesChartRangeTrack | undefined,
  laneIds?: string[]
): TimeRangeLane[] {
  if (!rangeTrack || !laneIds?.length) {
    return [];
  }

  const highlightedLaneIds = new Set(laneIds);

  return rangeTrack.lanes.filter((lane) => highlightedLaneIds.has(lane.id));
}
